/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * Professional approval status. `incomplete` = mentor has work to do (never completed, or declined with flagged sections). `pending` = ready for admin review. `approved` = live. `rejected` = deprecated legacy value, kept for back-compat only.
 */
export enum ProfessionalPrivateProfileStatus {
  incomplete = 'incomplete',
  pending = 'pending',
  approved = 'approved',
  rejected = 'rejected'
}
